// Auto-generated file - do not edit manually
export const version = {
  "commitHash": "a48db26",
  "commitDate": "2026-06-23 01:18",
  "branchName": "main",
  "commitUrl": "https://x-access-token:ghs_JcKqpFJg7XmEgkF0uwMkEUPQzUvF150pT4Ml@github.com/Terra-Planner/ui-web/commit/a48db26500d5d04c0d6044712301c2ed685a07f5",
  "branchUrl": "https://x-access-token:ghs_JcKqpFJg7XmEgkF0uwMkEUPQzUvF150pT4Ml@github.com/Terra-Planner/ui-web/tree/main",
  "buildDate": "2026-06-23T01:18:58.674Z"
}
